import { Action } from '@ngrx/store';

export enum loadDataActionType {
  LOAD = '[LOADDATA] load'
}
export class LoadDataAction implements Action {
  readonly type = loadDataActionType.LOAD;
  //add an optional payload
  constructor(public payload: any) {}
}


export type CrudCardAction = LoadDataAction;